<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="onCloseModal()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular" >{{ ('keys.data.profile.edit_address' | translate : {Default:'Edit  Address'}) ||"Edit  Address"}}</h2>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>
<ion-content>
 
    <form novalidate [formGroup]="editAddressForm">
      <!-- {{ editAddressForm.value | json }} -->
      <ion-grid>
        <ion-row>
          <ion-col >
            <ion-item lines="none" style="text-align: center;" class="paragraph-regular">
              <ion-input
                type="text"
                value="Permanent Mailing Address"
                formControlName="label"
                readonly
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
        
            <ion-row>
              <ion-col class="ion-no-padding" class="single-col-wider">
                <ion-card class="card-shadow-3"><ion-item lines="none">
                  <ion-label position="stacked"
                    >{{ ('keys.data.profile.address1' | translate : {Default:'Address Line 1'}) ||"Address Line 1"}}</ion-label
                  >
                  <ion-input
                    type="text"
                    placeholder="123 Main St"
                    formControlName="address1"
                  ></ion-input>
                </ion-item></ion-card>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="ion-no-padding" class="single-col-wider">
                <ion-card class="card-shadow-3"><ion-item lines="none">
                  <ion-label position="stacked"
                    >{{ ('keys.data.profile.city' | translate : {Default:'City'})
                    ||"City"}}</ion-label
                  >
                  <ion-input
                    type="text"
                    formControlName="city"
                  ></ion-input>
                </ion-item></ion-card>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="ion-no-padding" class="single-col-wider">
                <ion-card class="card-shadow-3">
                  <ion-item lines="none">
                    <ion-label position="stacked"
                      > {{ ('keys.data.common.province_or_state' | translate : {Default:'Province or State'})
                      ||"Province or State"}}</ion-label
                    >
                    <ion-select multiple="false" formControlName="prov">
                      <ion-select-option
                        *ngFor="let v of addresses['provinces']"
                        [value]="v.ProvID"
                        >{{v.ProvName}}</ion-select-option
                      >
                    </ion-select>
                  </ion-item>
                </ion-card>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="ion-no-padding" class="single-col-wider">
                <ion-card class="card-shadow-3">
                  <ion-item lines="none">
                    <ion-label position="stacked"
                      >{{ ('keys.data.common.postalcode_or_zipcode' | translate : {Default:'Postal/Zip Code'})
                      ||"Postal/Zip Code"}}</ion-label
                    >
                    <ion-input
                      type="text"
                      formControlName="postal"
                    ></ion-input>
                  </ion-item>
                </ion-card>
              </ion-col>
            </ion-row>
            
            
            
            <ion-row>
          <ion-col  class="single-col-wider">
            <ion-button
              expand="block"
             
              color="primary"
              (click)="onSaveChanges()"
              [disabled]="editAddressForm.invalid || editAddressForm.pristine"
            >
              {{ ('keys.data.common.save_changes' | translate : {Default:'Save Changes'}) || 'Save Changes'
              }}
            </ion-button>
          </ion-col>
        </ion-row>
        
      </ion-grid>
    </form>
    <!-- <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button (click)="onCloseModal()">
          {{ ('keys.data.common.close' | translate : {Default:'Close'}) ||"Close"}}
        </ion-button>
        <ion-button
          color="primary"
          (click)="onSaveChanges()"
          [disabled]="editAddressForm.invalid"
        >
          {{ ('keys.data.common.save_changes' | translate : {Default:'Save Changes'}) || 'Save Changes' }}
        </ion-button>
      </ion-buttons>
    </ion-toolbar> -->
 
</ion-content>
